import React from 'react';

function HowToPlayModal(props) {
  const isDark = props.theme === 'dark';
  const bg = isDark ? '#1e1e1e' : '#ffffff';
  const fg = isDark ? '#f1f1f1' : '#111111';
  const muted = isDark ? '#cfcfcf' : '#555555';
  return (
    <div role="dialog" aria-modal="true" aria-label="How to play" style={{ position: 'fixed', inset: 0, zIndex: 10000 }}>
      <div onClick={props.onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)' }}></div>
      <div style={{ position: 'relative', maxWidth: 640, margin: '64px auto', background: bg, color: fg, borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.35)' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${isDark ? '#333' : '#eee'}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>How to play</div>
          <button onClick={props.onClose} style={{ border: 'none', background: 'transparent', color: muted, cursor: 'pointer', fontSize: 22, lineHeight: 1 }} aria-label="Close rules">×</button>
        </div>
        <div style={{ padding: '16px 20px' }}>
          <div style={{ marginBottom: 12, fontSize: 14, color: muted }}>GrottoChess is chess turned into an auto-battler. You set up your pieces, press play, and watch the battle unfold.</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 12 }}>
            <section>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Setup</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>You always play as White.</li>
                <li>Place pieces anywhere on your half of the board.</li>
                <li>Once you’re ready, hit Start Battle and let the game play out automatically.</li>
              </ul>
            </section>
            <section>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Shop & Money</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Each round you get money to spend on new pieces.</li>
                <li>Prices vary: Pawns are cheap, Rooks cost more, etc.</li>
                <li>You keep your money between rounds.</li>
                <li>For every 5 money saved, you earn +1 extra interest money (max +3 per round).</li>
              </ul>
            </section>
            <section>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Battles</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>The AI controls Black and its army grows each round.</li>
                <li>Your pieces fight automatically once the battle starts.</li>
                <li>Survive, adapt, and outgrow the enemy setup.</li>
              </ul>
            </section>
            <section>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Goal</div>
              <div style={{ margin: 0 }}>
                See how far you can go against ever-escalating opponents. Build clever armies, experiment with setups, and try to last as long as possible!
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowToPlayModal;


